module.exports = __webpack_public_path__ + "img/32.8bc33d26.svg";